import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateHolidays = async (HolidaysObject, uid, SchoolID) => {
  try {
    const HolidaysCollection = collection(db, "Holidays");

    const data = HelperForMetaData({
      ...HolidaysObject,
      uid: uid,
      SchoolID: SchoolID,
    });
    await addDoc(HolidaysCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateHolidays;
